import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-profile-view-data',
    templateUrl: './profile-view-data.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./profile-view-data.component.scss'],
    standalone: false,
})
export class FiProfileViewDataComponent {
    @Input() label;
    @Input() content;
}

@Component({
    selector: 'fi-profile-view-data-label, fi-profile-view-data-content',
    template: '<ng-content></ng-content>',
    standalone: false,
})
export class FiProfileViewDataChildComponent {}
